import type { UiLocale } from '../app/ui-locale';
import type { FormField, TextAlign } from '../models/form';

export type FieldAlignmentChoice = 'auto' | TextAlign;

/**
 * RC4R3 stored `align: right` as the implicit default on nearly every field.
 * Treat that legacy shape as locale-default unless a newer schema explicitly
 * records an administrator alignment choice. Existing left/center/justify
 * values are preserved as explicit choices for backward compatibility.
 */
export function isFieldAlignmentExplicit(field: Pick<FormField, 'align' | 'alignmentExplicit'>): boolean {
  if (typeof field.alignmentExplicit === 'boolean') return field.alignmentExplicit;
  return Boolean(field.align && field.align !== 'right');
}

export function defaultFieldAlignment(locale: UiLocale): TextAlign {
  return locale === 'fa' ? 'right' : 'left';
}

export function resolveFieldAlignment(
  field: Pick<FormField, 'align' | 'alignmentExplicit'>,
  locale: UiLocale
): TextAlign {
  if (isFieldAlignmentExplicit(field) && field.align) return field.align;
  return defaultFieldAlignment(locale);
}

export function fieldAlignmentChoice(field: Pick<FormField, 'align' | 'alignmentExplicit'>): FieldAlignmentChoice {
  return isFieldAlignmentExplicit(field) && field.align ? field.align : 'auto';
}
